import { render, staticRenderFns } from "./TxRendererQuery.vue?vue&type=template&id=31ac3b0e&scoped=true&"
import script from "./TxRendererQuery.vue?vue&type=script&lang=js&"
export * from "./TxRendererQuery.vue?vue&type=script&lang=js&"
import style0 from "./TxRendererQuery.vue?vue&type=style&index=0&id=31ac3b0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ac3b0e",
  null
  
)

export default component.exports